import { z } from 'zod';
import { CollectorsOfArtistsSchemaShared } from '../../fields';

export const ReleasesInfo = z.array(
  z
    .object({
      id: z.string().nullish(),
      name: z.string().nullish(),
      artist: z.object({
        id: z.string(),
        name: z.string().nullish(),
      }),
      coverImage: z.object({
        id: z.string(),
        url: z.string().nullish(),
      }),
      staticCoverImage: z
        .object({
          id: z.string().nullish(),
          url: z.string().nullish(),
        })
        .nullish(),
      title: z.string(),
    })
    .nullish(),
);

export const EditCollectorsOfReleasesSchema = z
  .object({
    allArtistReleases: z.boolean(),
    allArtistCollaborations: z.boolean(),
    selectedReleaseIds: z.array(z.string()),
    releasesInfo: ReleasesInfo,
  })
  .transform(o => {
    return {
      allArtistReleases: o?.allArtistReleases ?? false,
      allArtistCollaborations: o?.allArtistCollaborations ?? false,
      selectedReleaseIds: o?.selectedReleaseIds ?? [],
      releasesInfo: o?.releasesInfo ?? [],
    };
  });

export const ArtistsInfo = z.array(
  z
    .object({
      id: z.string().nullish(),
      name: z.string().nullish(),
      user: z.object({
        username: z.string().nullish(),
        avatar: z
          .object({
            id: z.string().nullish(),
            url: z.string().nullish(),
          })
          .nullish(),
        publicAddress: z.string(),
      }),
    })
    .nullish(),
);

export const EditCollectorsOfArtistsSchema = CollectorsOfArtistsSchemaShared.extend({
  artistsInfo: ArtistsInfo,
})
  .nullish()
  .transform(o => {
    return {
      allArtistCollectors: o?.allArtistCollectors ?? true,
      allCollaboratingArtists: o?.allCollaboratingArtists ?? false,
      selectedArtistIds: o?.selectedArtistIds ?? [],
      artistsInfo: o?.artistsInfo ?? [],
    };
  });

export type EditCollectorsOfArtists = z.infer<typeof EditCollectorsOfArtistsSchema>;
export type EditCollectorsOfReleases = z.infer<typeof EditCollectorsOfReleasesSchema>;

export type EditCollectorsOfArtistsKeys = keyof EditCollectorsOfArtists;
export type EditCollectorsOfReleasesKeys = keyof EditCollectorsOfReleases;
